/**
/**
* CLASS WindowConfigurarRegla
*
* Contiene el contenedor principal de las configuraciones de las reglas imap
*
* @author Hector Morales <hector.morales@ikarosofttechnology.com>
*/

import React, { Component } from 'react';
import FormDataGrid from '../../data_grid/FormDataGrid';
import {cargarFilas} from '../../api_calls/ApiCalls';
import globalState from '../../configuration/GlobalState';
import alertify from 'alertifyjs';

class WindowConfigurarRegla extends Component { 
    constructor(props){
        super(props);
        this.state = {
            idRow : 0,            
            database : globalState.getState().companyData[0].bd  
        };
    } 
    componentWillMount(){    
        //CARGAR LOS DATOS DEL FORMULARIO
        let sqlParams = { 
                            sqlWhere : [
                                " AND id="+this.props.params.idRegla
                            ],                                                     
                            mode : 'rows'                                                 
                        }

        cargarFilas('imap_reglas','',1,0,'','',sqlParams,'rows',this.state.database)
        .then(res => {
            var response = res.data; 
            if (response.msg === "error") {
                alertify.alert('Error!', 'Ha ocurrido un error accesando a la base de datos!<br />Codigo de Error: '+response.detail);
            } 
            else{
                let idRow = 0;               
                if(response.length > 0){
                    idRow = response[0];                    
                }
                this.setState({ idRow: idRow });
            }
        })
        .catch( err => {            
            alertify.alert('Error!', 'No se ha logrado la conexion con el servidor!<br />'+err);                            
        }); 
    }
    cerrarVentana(){
        this.props.params.funcionClick('WelcomePage');
        this.props.params.funcionClick('ImapReglas');
        globalState.dispatch({
                type   : "windowConfigurarRegla",
                params : {
                              visible : false,
                         }
        });
    } 
    render() {         
        let where = " AND id < 1";
        if(this.state.idRow !== 0){
            where = " AND atencion_"+this.state.idRow.tipo+"s='true'";
        }               
        return (//carga el componente que contiene la grilla de datos                            
            <div style={{top:'-10px',position:'relative'}}>             
                <FormDataGrid 
                    funcionClick = {this.props.funcionClick} 
                    parametro = {
                                    {
                                        idRow : this.state.idRow,
                                        mainContainer : 'WindowConfigurarRegla',
                                        formulario : true,
                                        titulo : 'Regla',
                                        apiField : 'imap_reglas', 
                                        enableBtnEdit : true,
                                        functionCancel : this.cerrarVentana.bind(this),
                                        funcionAfterInsert : this.cerrarVentana.bind(this),
                                        funcionAfterUpdate : this.cerrarVentana.bind(this),                                                                        
                                        formFields :  [
                                                        {
                                                            label : 'Area de Servicio *',
                                                            field : 'id_area',
                                                            type  : 'select',
                                                            validation : '',
                                                            required : 'true',
                                                            dinamic : 'true',
                                                            apiField : 'areas_servicio',
                                                            valueName : 'nombre',
                                                            updateTo : 'id_categoria',
                                                            sqlParams : {
                                                                            sqlCols : [
                                                                                'id',
                                                                                'nombre'                                
                                                                            ],
                                                                            sqlWhere : [ where ],                                                                                                                                                                                                                                    
                                                                        },
                                                            tooltip : 'Seleccione el area de servicio',                                                                                                
                                                        },
                                                        {
                                                            label : 'Categoria *',
                                                            field : 'id_categoria',
                                                            type  : 'select',
                                                            validation : '',
                                                            required : 'true',
                                                            dinamic : 'true',
                                                            apiField : 'areas_servicio_categorias',
                                                            valueName : 'nombre',                                       
                                                            updateTo : 'id_subcategoria',
                                                            fieldUpdate : 'id_area', 
                                                            sqlParams : {
                                                                            sqlCols : [
                                                                                'id',
                                                                                'nombre'                                
                                                                            ],
                                                                            sqlWhere : [ where ],                                                   
                                                                        },
                                                            tooltip : 'Seleccione la categoria de la incidencia' 
                                                        }, 
                                                        {
                                                            label : 'Subcategoria *',
                                                            field : 'id_subcategoria',
                                                            type  : 'select',
                                                            validation : '',
                                                            required : 'true',
                                                            dinamic : 'true',
                                                            apiField : 'areas_servicio_subcategorias',
                                                            valueName : 'nombre',
                                                            fieldUpdate : 'id_categoria',                                        
                                                            sqlParams : {
                                                                            sqlCols : [
                                                                                'id',
                                                                                'nombre'                                
                                                                            ],                                                                                                                                                         
                                                                        },
                                                            tooltip : 'Seleccione la Subcategoria' 
                                                        },                                                                                                                                                                       
                                                        {
                                                            label : '',
                                                            field : 'id',
                                                            type  : 'hidden',
                                                            validation : '',
                                                            value : this.props.params.idRegla,
                                                            required : 'true'                                        
                                                        },
                                                      ] 
                                    }
                                } 
                            
                /> 
            </div>                         
        )
    } 
}

export default WindowConfigurarRegla